import styled from '@emotion/styled'
import { Button, Card } from 'react-bootstrap'
import theme from '../../constants/theme'
import PrimaryButton from '../buttons/PrimaryButton'

// --- Invitation Card UI ---

export const InvitationCard = styled.div({
  backgroundColor: 'white',
  borderRadius: '20px',
  overflow: 'hidden',
  width: '100%',
  margin: '0 auto',
})

export const InvitationHeader = styled.div({
  background: `linear-gradient(145deg, #1068A0 0%, ${theme.talentinoSpecialBlue} 50%, #043A5E 100%)`,
  padding: '28px 24px 32px',
  color: 'white',
  position: 'relative',
  overflow: 'hidden',
  '&::before': {
    content: '""',
    position: 'absolute',
    top: '-30px',
    right: '-30px',
    width: '140px',
    height: '140px',
    borderRadius: '50%',
    border: '2px solid rgba(255,255,255,0.12)',
  },
  '&::after': {
    content: '""',
    position: 'absolute',
    top: '20px',
    right: '20px',
    width: '80px',
    height: '80px',
    borderRadius: '50%',
    border: '2px solid rgba(255,255,255,0.08)',
  },
})

export const InvitationPill = styled.span({
  display: 'inline-flex',
  alignItems: 'center',
  gap: '6px',
  backgroundColor: 'rgba(255,255,255,0.18)',
  borderRadius: '20px',
  padding: '4px 12px',
  fontSize: '12px',
  fontWeight: '500',
  color: 'white',
  marginBottom: '14px',
})

export const InvitationTitle = styled.h1({
  fontSize: '22px',
  fontWeight: '700',
  color: 'white',
  marginBottom: '6px',
  lineHeight: '1.2',
})

export const InvitationSubtitle = styled.p({
  fontSize: '13px',
  color: 'rgba(255,255,255,0.75)',
  margin: '0',
  fontWeight: '400',
})

export const InvitationBody = styled.div({
  padding: '16px',
  backgroundColor: 'white',
  display: 'flex',
  flexDirection: 'column',
  gap: '12px',
})

export const DateInfoRow = styled.div({
  display: 'flex',
  alignItems: 'center',
  gap: '14px',
  padding: '14px',
  borderRadius: '12px',
  border: '1px solid #e8ecf0',
})

export const DateBox = styled.div({
  background: '#0A2E4A',
  borderRadius: '10px',
  padding: '8px 12px',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  minWidth: '52px',
  flexShrink: 0,
})

export const DateBoxMonth = styled.span({
  fontSize: '10px',
  fontWeight: '600',
  color: 'rgba(255,255,255,0.8)',
  textTransform: 'uppercase',
  letterSpacing: '1px',
})

export const DateBoxDay = styled.span({
  fontSize: '28px',
  fontWeight: '700',
  color: 'white',
  lineHeight: '1.1',
})

export const TimeInfoWrapper = styled.div({
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  gap: '6px',
})

export const TimeInfoRow = styled.div({
  display: 'flex',
  alignItems: 'center',
  gap: '6px',
  fontSize: '13px',
  fontWeight: '500',
  color: '#374151',
  flexWrap: 'wrap',
})

export const MutedTimeInfoRow = styled(TimeInfoRow)({
  color: '#6B7280',
})

export const AvailableDot = styled.span({
  width: '7px',
  height: '7px',
  borderRadius: '50%',
  backgroundColor: '#16A34A',
  display: 'inline-block',
})

export const AvailableBadge = styled.span({
  backgroundColor: '#DCFCE7',
  color: '#16A34A',
  fontSize: '11px',
  fontWeight: '500',
  padding: '2px 8px',
  borderRadius: '20px',
  marginLeft: 'auto',
  whiteSpace: 'nowrap',
  display: 'flex',
  alignItems: 'center',
  gap: '4px',
})

export const InterviewerRow = styled.div({
  display: 'flex',
  alignItems: 'center',
  gap: '12px',
  padding: '12px 14px',
  borderRadius: '12px',
  backgroundColor: theme.talentinoLightBlueBackground,
})

export const InterviewerIconWrap = styled.div({
  width: '40px',
  height: '40px',
  borderRadius: '50%',
  background: 'linear-gradient(135deg, #7C3AED 0%, #5B21B6 100%)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexShrink: 0,
})

export const InterviewerName = styled.span({
  display: 'block',
  fontSize: '14px',
  fontWeight: '600',
  color: '#111827',
})

export const InterviewerSubtext = styled.span({
  display: 'block',
  fontSize: '12px',
  color: theme.talentinoBlue,
})

export const OutlinedButton = styled(Button)(
  ({ color: btnColor, borderColor }) => ({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '6px',
    padding: '7px 12px',
    height: '38px',
    flex: 1,
    borderRadius: '20px',
    backgroundColor: 'transparent !important',
    border: `1px solid ${borderColor || '#d1d5db'} !important`,
    color: `${btnColor || '#374151'} !important`,
    fontSize: '12px',
    fontWeight: '500',
    '&:hover': {
      backgroundColor: `${btnColor ? `${btnColor}10` : '#f9fafb'} !important`,
    },
    '&:focus': {
      boxShadow: 'none !important',
    },
  }),
)

export const ActionButtonsRow = styled.div({
  display: 'flex',
  gap: '8px',
})

export const CardBody = styled(Card.Body)({
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
})

export const SelectedTimeContainer = styled.div((props) => ({
  width: '50%',
  padding: '0.75rem 1rem',
  backgroundColor: props.theme?.neutralLight || '#f8f9fa',
  borderRadius: '0.5rem',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  marginBottom: '1rem',
}))

export const TimeInfo = styled.div((props) => ({
  display: 'flex',
  alignItems: 'center',
  color: props.theme?.neutralDark || '#495057',
  fontWeight: 600,
}))

export const IconWrapper = styled.span({
  display: 'inline-flex',
  alignItems: 'center',
  margin: '0 0.5rem',
})

export const TimeButtonsContainer = styled.div({
  width: '50%',
  padding: '4px',
})

export const TimeButton = styled(PrimaryButton)({
  width: '100%',
  padding: '0.25rem 0.5rem',
  fontSize: '12px',
})

export const ActionsContainer = styled.div({
  width: '50%',
  margin: '0 auto',
})

export const ActionButton = styled(PrimaryButton)({
  whiteSpace: 'nowrap',
})

export const ModalOverlay = styled.div({
  position: 'fixed',
  inset: 0,
  zIndex: 50,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '1rem',
})

export const ModalBackdrop = styled.div({
  position: 'absolute',
  inset: 0,
  backgroundColor: 'rgba(0, 0, 0, 0.5)',
  zIndex: '100',
})

export const ModalContent = styled.div({
  backgroundColor: 'white',
  borderRadius: '0.5rem',
  boxShadow:
    '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
  width: '100%',
  maxWidth: '42rem',
  height: '80vh',
  display: 'flex',
  flexDirection: 'column',
  zIndex: 9999,
})

export const ModalHeader = styled.div({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: '1rem',
  borderBottom: '1px solid #e5e7eb',
})

export const ModalTitle = styled.h2({
  fontSize: '1.25rem',
  fontWeight: 600,
  color: '#111827',
})

export const ModalSubtitle = styled.p({
  fontSize: '12px',
  color: '#4b5563',
  marginTop: '0.25rem',
})

export const CloseButton = styled(Button)({
  backgroundColor: 'transparent',
  border: 'none',
  padding: '0.5rem',
  borderRadius: '0.5rem',
  color: '#6b7280',
  transition: 'color 0.2s, background-color 0.2s',
  '&:hover': {
    backgroundColor: '#f3f4f6 !important',
    color: '#4b5563 !important',
  },
  '&:focus': {
    backgroundColor: '#f3f4f6 !important',
    color: '#4b5563 !important',
  },
  '&:active': {
    backgroundColor: '#f3f4f6 !important',
    color: '#4b5563 !important',
  },
})

export const ModalBody = styled.div({
  flex: 1,
  overflowY: 'auto',
  padding: '1rem',
})

export const TimeSlotContainer = styled.div((props) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '0.75rem',
  borderRadius: '0.5rem',
  transition: 'background-color 0.2s',
  minWidth: '60px',
  ...(props.isAvailable
    ? {
        backgroundColor: 'white',
        border: '1px solid #e5e7eb',
        color: '#111827',
        cursor: 'pointer',
        '&:hover': { backgroundColor: '#f9fafb' },
      }
    : {
        backgroundColor: '#f9fafb',
        color: '#9ca3af',
        cursor: 'not-allowed',
      }),
}))

export const TimeIconWrapper = styled.div({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
})

export const TimeText = styled.span({
  fontSize: '12px',
  fontWeight: 500,
  marginLeft: '0.5rem',
})

export const CalendarContainer = styled.div({
  width: '100%',
  backgroundColor: 'white',
  borderRadius: '0.5rem',
  padding: '1rem',
})

export const CalendarHeader = styled.div({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  marginBottom: '1.5rem',
})

export const MonthNavButton = styled(Button)({
  backgroundColor: 'transparent',
  border: 'none',
  color: '#4b5563',
  padding: '0.5rem',
  borderRadius: '0.5rem',
  transition: 'background-color 0.2s',
  '&:hover': {
    backgroundColor: '#f3f4f6 !important',
    color: '#4b5563 !important',
  },
  '&:focus': {
    backgroundColor: '#f3f4f6 !important',
    color: '#4b5563 !important',
  },
  '&:active': {
    backgroundColor: '#f3f4f6 !important',
    color: '#4b5563 !important',
  },
})

export const MonthTitle = styled.h2({
  fontSize: '1rem',
  fontWeight: 600,
  color: '#111827',
})

export const DaysGrid = styled.div({
  display: 'grid',
  gridTemplateColumns: 'repeat(7, 1fr)',
  marginBottom: '0.5rem',
})

export const DayHeader = styled.div({
  textAlign: 'center',
  fontWeight: 500,
  color: '#4b5563',
  fontSize: '12px',
  padding: '0.5rem',
})

export const CalendarGrid = styled.div({
  display: 'grid',
  gridTemplateColumns: 'repeat(7, 1fr)',
  gap: '0.25rem',
})

export const DayCell = styled.div({
  position: 'relative',
  padding: '0.25rem',
})

const getDayButtonStyles = (props) => {
  if (props.isSelected)
    return { backgroundColor: theme.brandColorOrange, color: 'white' }
  if (props.isAvailable && props.hasSlots)
    return { '&:hover': { backgroundColor: '#f9fafb' }, cursor: 'pointer' }
  return { backgroundColor: '#f9fafb', color: '#9ca3af', cursor: 'not-allowed' }
}

export const DayButton = styled.div((props) => ({
  height: '2.5rem',
  position: 'relative',
  textAlign: 'center',
  borderRadius: '0.5rem',
  transition: 'background-color 0.2s',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  ...getDayButtonStyles(props),
  ...(props.isToday && { fontWeight: 600 }),
}))

export const SlotIndicator = styled.div({
  position: 'absolute',
  top: '-0.375rem',
  right: '-0.375rem',
  width: '0.75rem',
  height: '0.75rem',
  borderRadius: '9999px',
  border: '2px solid white',
  backgroundColor: theme.brandColorOrange,
})

export const CalendarLegend = styled.div({
  marginTop: '1rem',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '1rem',
  fontSize: '12px',
})

export const LegendItem = styled.div({
  display: 'flex',
  alignItems: 'center',
})

const getLegendBoxStyles = (variant) => {
  switch (variant) {
    case 'selected':
      return { backgroundColor: theme.brandColorOrange, color: 'white' }
    case 'unavailable':
      return { backgroundColor: '#f9fafb', color: '#9ca3af' }
    case 'hasSlots':
      return { color: '#111827' }
    default:
      return {}
  }
}

export const LegendBox = styled.div((props) => ({
  width: '1.5rem !important',
  height: '1.5rem !important',
  borderRadius: '0.5rem',
  marginRight: '0.5rem',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  fontSize: '12px',
  ...getLegendBoxStyles(props.variant),
}))

export const LegendText = styled.span({
  color: '#4b5563',
})

export const SlotIndicatorWrapper = styled.div({
  position: 'relative',
  width: '1.5rem',
  height: '1.5rem',
  marginRight: '0.5rem',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
})

export const AvailableDatesSection = styled.div({
  marginTop: '2rem',
})

export const SectionHeader = styled.div({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  marginBottom: '0.5rem',
})

export const SectionTitle = styled.h3({
  fontSize: '1rem',
  fontWeight: 600,
  color: '#111827',
})

export const DateDisplay = styled.span({
  fontSize: '12px',
  color: '#4b5563',
})

export const SlotsGrid = styled.div({
  display: 'grid',
  gridTemplateColumns: 'repeat(2, 1fr)',
  gap: '0.75rem',
  '@media (min-width: 640px)': { gridTemplateColumns: 'repeat(3, 1fr)' },
})

export const NoSlotsMessage = styled.div({
  textAlign: 'center',
  padding: '1.5rem 1rem',
  backgroundColor: '#f9fafb',
  borderRadius: '0.5rem',
})

export const NoSlotsText = styled.p({
  color: '#6b7280',
})

export const NoSlotsSubtext = styled.p({
  fontSize: '12px',
  color: '#9ca3af',
  marginTop: '0.25rem',
})

export const BookedBadge = styled.div({
  position: 'absolute',
  top: '0.25rem',
  right: '0.25rem',
  backgroundColor: '#ef4444',
  color: 'white',
  padding: '0.15rem 0.4rem',
  borderRadius: '0.3rem',
  fontSize: '10px',
  fontWeight: 'bold',
  zIndex: 1,
})

export const SlotConflictAlert = styled.div({
  display: 'flex',
  alignItems: 'center',
  gap: '10px',
  padding: '12px 14px',
  borderRadius: '12px',
  backgroundColor: '#FDF1F0',
  border: '1px solid #F2CBC8',
  color: theme.talentinoRed,
  fontSize: '13px',
  fontWeight: '500',
  lineHeight: '1.4',
})

// --- Single offered slot (approve / decline, no picker) ---

export const ProposedDot = styled(AvailableDot)({
  backgroundColor: '#B45309',
})

export const ProposedBadge = styled(AvailableBadge)({
  backgroundColor: '#FEF3C7',
  color: '#B45309',
})

export const SingleSlotHint = styled.p({
  margin: '0',
  fontSize: '13px',
  color: '#6B7280',
  lineHeight: '1.5',
})
